exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#block7 article p{width:90%;color:#222831;font-size:1.6em;line-height:24px;margin:0 auto 25px}#block7 figure{padding:40px 0;text-align:center}@media (max-width:640px){#block7 article p{width:100%;margin:20px auto;text-align:left!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37e80e1f","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/blocks/Block7.vue
// module id = 81
// module chunks = 0